// Compare package types while making them all lower case
export function comparePackageTypes(type1, type2) {
  return type1?.toLowerCase() === type2?.toLowerCase();
}
